import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaWineBottle } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useCartStore } from '../context/store';
import { toast } from 'react-toastify';
import '../styles/ProductCard.css';
import { getPrimaryImage } from '../utils/image';

const ProductCard = ({ product }) => {
  const addItem = useCartStore((state) => state.addItem);
  const primaryImage = getPrimaryImage(product.immagini);
  const ratingMedia = product.ratingMedia || 0;
  const ratingCount = product.ratingCount || 0;

  const renderBottleRating = (value) => {
    const ratingValue = Math.max(0, Math.min(5, value || 0));
    return (
      <div style={{ display: 'flex', gap: '0.25rem', alignItems: 'center' }}>
        {[1, 2, 3, 4, 5].map((rating) => (
          <span
            key={rating}
            style={{
              color: rating <= ratingValue ? 'var(--gold-primary)' : 'var(--text-muted)',
              opacity: rating <= ratingValue ? 1 : 0.5,
              fontSize: '0.9rem',
              lineHeight: 1
            }}
            aria-hidden="true"
          >
            <FaWineBottle />
          </span>
        ))}
      </div>
    );
  };

  const handleAddToCart = (e) => {
    e.preventDefault();
    addItem(product, 1);
    toast.success(`${product.nome} aggiunto al carrello!`);
  };

  const prezzoFinale = product.prezzoScontato || product.prezzoBase;
  const hasSconto = product.prezzoScontato && product.prezzoScontato < product.prezzoBase;
  const scontoPercentuale = hasSconto
    ? Math.round(((product.prezzoBase - product.prezzoScontato) / product.prezzoBase) * 100)
    : 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Link to={`/prodotto/${product._id}`} className="product-card">
        <div className="product-image-container">
          {hasSconto && (
            <div className="product-badge">-{scontoPercentuale}%</div>
          )}
          {product.inEvidenza && (
            <div className="product-badge product-badge-gold">In Evidenza</div>
          )}
          <div className="product-image">
            {primaryImage.url ? (
              <img
                src={primaryImage.url}
                alt={primaryImage.altText || product.nome}
                onError={(e) => {
                  e.target.src = '/images/placeholder.svg';
                }}
              />
            ) : (
              <div className="product-placeholder">
                <FaWineBottle />
              </div>
            )}
          </div>
        </div>

        <div className="product-content">
          <div className="product-category">{product.tipologia}</div>
          <h3 className="product-title">{product.nome}</h3>
          {product.produttore?.nome && (
            <p className="product-producer">{product.produttore.nome}</p>
          )}
          <p className="product-year">Annata {product.annata}</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.5rem' }}>
            {renderBottleRating(Math.round(ratingMedia))}
            <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
              {ratingMedia ? ratingMedia.toFixed(1) : '0.0'} ({ratingCount})
            </span>
          </div>

          <div className="product-footer">
            <div className="product-price">
              {hasSconto && (
                <span className="product-price-old">€{product.prezzoBase.toFixed(2)}</span>
              )}
              <span className="product-price-current">€{prezzoFinale.toFixed(2)}</span>
            </div>

            <button
              className="btn-add-cart"
              onClick={handleAddToCart}
              disabled={product.quantitaDisponibile === 0}
            >
              <FaShoppingCart />
            </button>
          </div>

          {product.quantitaDisponibile === 0 && (
            <div className="product-out-of-stock">Esaurito</div>
          )}
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
